import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userProfile: null,
  userProfileLoading: false,
  logoutModal: false,
  logoutLoading: false,
  createCouponModal: false,
};

export const appReducer = createSlice({
  name: "app",
  initialState,
  reducers: {
    setUserProfile: (state, action) => {
      state.userProfile = action.payload;
    },
    setUserProfileLoading: (state, action) => {
      state.userProfileLoading = action.payload;
    },
    setLogoutModal: (state, action) => {
      state.logoutModal = action.payload;
    },
    setLogoutLoading: (state, action) => {
      state.logoutLoading = action.payload;
    },
    setCreateCouponModal: (state, action) => {
      state.createCouponModal = action.payload;
    },
  },
});

export const {
  setUserProfile,
  setUserProfileLoading,
  setLogoutModal,
  setLogoutLoading,
  setCreateCouponModal,
} = appReducer.actions;

export default appReducer.reducer;
